/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/*!

 =========================================================
 * Paper Dashboard Pro Angular - v1.3.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-angular
 * Copyright 2018 Creative Tim (http://www.creative-tim.com)

 =========================================================

 * The above copyright notice and this permission notice shall be included
 in all copies or substantial portions of the Software.

 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Analytics, Auth } from 'aws-amplify';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}


const amplifyConfig = {
  Auth: {
    identityPoolId: 'us-east-1:6d6f68c5-4d84-4913-b0b3-f33b88a72b44',
    region: 'us-east-1',
  },
};
// Initialize Amplify
Auth.configure(amplifyConfig);

const analyticsConfig = {
  AWSPinpoint: {
    // Amazon Pinpoint App Client ID
    appId: 'fd959d8885fe4d6b83f8d81e0553d126',
    // Amazon service region
    region: 'us-east-1',
    mandatorySignIn: false,
  },
};

Analytics.configure(analyticsConfig);

// // // Record an event
// Analytics.record('some-event-name');

// // // Record a custom event
// Analytics.record({
//   name: 'Album',
//   attributes: { genre: 'Rock', year: '1989' },
// });


platformBrowserDynamic().bootstrapModule(AppModule);
